import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import s from "./KazakhstanRemoteImigration.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getKazakhstanRemoteMigrationDetails,
  getKazakhstanRemoteMigrationList,
  getKazakhstanTripPreparationDetails,
  getRussiaHiVMigrantsDetails,
} from "../../redux/InformationSlice";
import { useParams } from "react-router-dom";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import InCountry from "../../Components/InCountry/InCountry";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import { Seo } from "../../Seo";

const KazakhstanRemoteImigration = () => {
  const data = useSelector(
    (state: RootState) => state.info.kazakhstanRemoteMigrationDetails,
  );

  const params = useParams();
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();

  useEffect(() => {
    dispatch(getKazakhstanRemoteMigrationDetails(Number(params.id)));
  }, [params]);

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Seo
        title="Дистанционный учет при ВИЧ для граждан Кыргызстана и Таджикистана"
        description="Как гражданам Кыргызстана и Таджикистана встать на учет по ВИЧ дистанционно."
        url="https://www.vputi.org/kazakhstan/hiv/treatment/remote/1"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство Казахстана / Для мигрантов, живущих с ВИЧ  / Как получать лечение / Как встать на учёт дистанционно",
            path: "/kazakhstan/hiv/treatment/2",
          }}
        />

        <ContactButtons />
        <div className={s.text}>
          <div className={s.title}>{data?.title_1}</div>
          <div
            className={s.body}
            dangerouslySetInnerHTML={{ __html: data?.body_1 ?? "" }}
          ></div>
          <div
            className={s.yellow_wrapper}
            dangerouslySetInnerHTML={{ __html: data?.body_2 ?? "" }}
          ></div>
          <div className={s.title}>{data?.title_3}</div>
          <div
            className={s.body}
            dangerouslySetInnerHTML={{ __html: data?.body_3 ?? "" }}
          ></div>
          <div
            className={s.yellow_wrapper}
            dangerouslySetInnerHTML={{ __html: data?.body_4 ?? "" }}
          ></div>
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default KazakhstanRemoteImigration;
